import styled, { css } from "styled-components"

export const Main = styled.div`
  height: 31px;
  width: 40.5px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 5px 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-right: 19.5px;

  @media (max-width: 1149px) {
    display: none;
  }

  &:hover {
    div {
      background: #ce9638;

      &:nth-child(4),
      :nth-child(5),
      :nth-child(6) {
        background: linear-gradient(
          180deg,
          rgba(206, 150, 56, 1) 0%,
          rgba(234, 230, 156, 1) 50%,
          rgba(206, 150, 56, 1) 100%
        );
      }
    }
  }

  div {
    height: 7px;
    width: 100%;
    ${props =>
      props.displayType === "grid"
        ? css`
            background: #ce9638;

            &:nth-child(4),
            :nth-child(5),
            :nth-child(6) {
              background: linear-gradient(
                180deg,
                rgba(206, 150, 56, 1) 0%,
                rgba(234, 230, 156, 1) 50%,
                rgba(206, 150, 56, 1) 100%
              );
            }
          `
        : css`
            background: #111111;
          `}
  }
`
